<template>
  <div>
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="row">
      <div class="col-lg-12">
        <div class="box">
          <div class="box-header">
            <h4 class="box-title">
              <i class="icofont-chart-bar-graph"></i> Série histórica
            </h4>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-lg-12">
                <apexchart
                  type="line"
                  height="350"
                  :options="chartOptions"
                  :series="chartData"
                  ref="chartGraficoResultado"
                ></apexchart>
                <FonteSincronizadorC />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    equipe: {
      type: [Object, String],
      default: '',
    },
    micro_area: {
      type: String,
      default: '',
    },
  },
  components: {
    PulseLoader,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      size: '40px',
      color: '#0D98BB',
      chartData: [],
      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        title: {
          text: 'Gestantes puérperas',
          align: 'center',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 0,
          max: 100,
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
        },
        markers: {
          size: 5,
        },
        colors: ['#008FFB', '#ff9933', '#025e1b'],
      },
      x_axis: [],
      dataChartMunicipio: [],
      dataChartEquipe: [],
      dataChartMicroArea: [],
    }
  },
  mounted() {},
  watch: {
    equipe: {
      handler(newValue, oldValue) {
        // console.log(newValue)
      },
      deep: true,
    },
    micro_area: {
      handler(newValue, oldValue) {
        // console.log(newValue)
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    serieHistoricaMunicipio(dadosSerieHistorica) {
      let dataItens = dadosSerieHistorica
      dataItens = dataItens.filter((item) => {
        return (
          item.ibge === this.$store.state.cod_ibge &&
          item.nivel == 1 &&
          item.indicador == 52
        )
      })

      let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
      let array_chart_municipio = []
      let array_xaxis = []
      //carregar eixo x
      for (let i = 0; i < dataItens12meses.length; i++) {
        array_xaxis.push(dataItens12meses[i].mes_ano)
      }
      // carregar dados do município
      for (let i = 0; i < dataItens12meses.length; i++) {
        let dados = JSON.parse(dataItens12meses[i].dados)
        array_chart_municipio.push(dados.resultado)
      }
      this.$refs.chartGraficoResultado.updateOptions({
        xaxis: {
          categories: array_xaxis,
        },
      })
      this.xaxis = array_xaxis
      this.$refs.chartGraficoResultado.updateSeries([
        {
          name: this.$store.state.cidade,
          data: array_chart_municipio,
        },
      ])
      this.dataChartMunicipio = array_chart_municipio
    },

    serieHistoricaEquipe(dadosSerieHistorica, equipe) {
      let array_chart_equipe = []
      for (let i = 0; i < this.xaxis.length; i++) {
        var eixo_x_atual = this.xaxis[i]
        let dataItens = dadosSerieHistorica
        dataItens = dataItens.filter((item) => {
          return (
            item.ine == equipe.ine_esf_eap &&
            item.nivel == 2 &&
            item.indicador == 52
          )
        })

        let dataItens12meses = dataItens.slice(
          Math.max(dataItens.length - 12, 0)
        )
        for (const item of dataItens12meses) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            let dados = JSON.parse(item.dados)
            resultado = dados.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_equipe.push(resultado)
      }
      this.dataChartEquipe = array_chart_equipe
      this.$refs.chartGraficoResultado.updateSeries([
        {
          name: this.$store.state.cidade,
          data: this.dataChartMunicipio,
        },
        {
          name: equipe.no_equipe,
          data: array_chart_equipe,
        },
      ])
    },

    serieHistoricaMicroArea(dadosSerieHistorica, equipe, micro_area) {
      let array_chart_micro_area = []
      for (let i = 0; i < this.xaxis.length; i++) {
        var eixo_x_atual = this.xaxis[i]
        let dataItens = dadosSerieHistorica
        dataItens = dataItens.filter((item) => {
          return (
            item.ine == equipe.ine_esf_eap &&
            item.micro_area == micro_area &&
            item.nivel == 3 &&
            item.indicador == 52
          )
        })

        let dataItens12meses = dataItens.slice(
          Math.max(dataItens.length - 12, 0)
        )
        for (const item of dataItens12meses) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            let dados = JSON.parse(item.dados)
            resultado = dados.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_micro_area.push(resultado)
      }
      this.dataChartMicroArea = array_chart_micro_area
      this.$refs.chartGraficoResultado.updateSeries([
        {
          name: this.$store.state.cidade,
          data: this.dataChartMunicipio,
        },
        {
          name: equipe.no_equipe,
          data: this.dataChartEquipe,
        },
        {
          name: 'MICROÁREA ' + micro_area,
          data: array_chart_micro_area,
        },
      ])
    },
  },
}
</script>

<style></style>
